import { IconButton, CircularProgress, Box, Tooltip } from '@material-ui/core'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import CloseIcon from '@material-ui/icons/Close'

interface PlayStopButtonProps {
  running: boolean
  handleStart: () => void
  handleStop: () => void
  disabled?: boolean
  error?: boolean
  queued?: boolean
  remoteRunning: boolean
}

export default function PlayStopButton({
  running,
  handleStart,
  handleStop,
  disabled = false,
  error = false,
  queued = false,
  remoteRunning,
}: PlayStopButtonProps): JSX.Element {
  return (
    <Box
      position='relative'
      width={40}
      height={40}
      marginRight={2}
      style={{
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      {running || queued ? (
        <>
         <CircularProgress 
            size={40}
            style={{
              color: queued ? 'lightgrey' : undefined,
              animation: queued ? 'spin 60s linear infinite' : undefined,
            }} 
          />
          {!queued && (
            <IconButton
              onClick={handleStop}
              size='small'
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '40px',
                height: '40px',
              }}
            >
              <CloseIcon fontSize='small' />
            </IconButton>
          )}
        </>
      ) : error ? (
        <Tooltip title='Execution has failed' arrow>
          <IconButton
            onClick={handleStart}
            color='secondary'
            size='small'
            style={{
              width: '40px',
              height: '40px',
            }}
          >
            <PlayArrowIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton
          disabled={remoteRunning}
          onClick={handleStart}
          color='primary'
          size='small'
          style={{
            width: '40px',
            height: '40px',
          }}
        >
          <PlayArrowIcon />
        </IconButton>
      )}
    </Box>
  )
}
